document
  .querySelectorAll(".kart-collection-status")
  .forEach(function (section) {
    section.addEventListener("click", function (e) {
      const openBtn = e.target.closest(".status-info");
      if (openBtn) {
        const container = openBtn.closest(".user-status-wrapper");
        let modal = container ? container.querySelector(".status-modal") : null;

        if (!modal) modal = document.querySelector(".status-modal");

        if (!modal) return;

        modal.classList.remove("hidden");
        modal.setAttribute("aria-hidden", "false");

        const closeBtn = modal.querySelector(".status-modal__close");
        if (closeBtn) closeBtn.focus();

        return;
      }

      const closeBtn = e.target.closest(".status-modal__close");
      if (closeBtn) {
        const modal = closeBtn.closest(".status-modal");
        if (modal) {
          modal.classList.add("hidden");
          modal.setAttribute("aria-hidden", "true");
        }
        return;
      }

      if (e.target.classList && e.target.classList.contains("status-modal")) {
        e.target.classList.add("hidden");
        e.target.setAttribute("aria-hidden", "true");
        return;
      }
    });
  });

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document
      .querySelectorAll(".status-modal:not(.hidden)")
      .forEach(function (m) {
        m.classList.add("hidden");
        m.setAttribute("aria-hidden", "true");
      });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".kart-collection-status").forEach((section) => {
    const dropdown = document.querySelector(".status-dropdown");
    const selected = dropdown.querySelector(".dropdown-selected");
    const selectedArea = dropdown.querySelector(".status-dropdown-title");
    const options = dropdown.querySelectorAll(".dropdown-options li");
    const products = document.querySelectorAll(".collection-status li");

    selectedArea.addEventListener("click", () => {
      dropdown.classList.toggle("open");
    });

    options.forEach((option) => {
      option.addEventListener("click", () => {
        const selectedStatus = option.dataset.status;
        selected.textContent = option.textContent;
        dropdown.classList.remove("open");

        products.forEach((product) => {
          const productStatus = product.dataset.status;
          let shouldShow = false;

          if (selectedStatus === "alle") {
            // Zeige alle Produkte
            shouldShow = true;
          } else {
            // Zeige nur Produkte mit exakt dem ausgewählten Status
            shouldShow = productStatus === selectedStatus;
          }

          if (shouldShow) {
            product.style.display = "flex";
          } else {
            product.style.display = "none";
          }
        });
      });
    });

    document.addEventListener("click", function (e) {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove("open");
      }
    });
  });
});
